import { routerReducer as routing } from 'react-router-redux'
import { combineReducers } from 'redux'

const topbarButtons = (state = [], action) => {
  switch(action.type) {
    case 'SET_TOPBAR_BUTTONS':
      return action.buttons;
    default:
      return state;
  }
}

const breadcrumbsRouteTitles = (state = {}, action) => {
  switch(action.type) {
    case 'ADD_BREADCRUMBS_ROUTE_TITLES':

      //cloning the state
      let newState = {};
      for (var key in state) {
        if (state.hasOwnProperty(key)) {
          newState[key] = {...state[key]};
        }
      }

      //adding new titles
      for (var key2 in action.breadcrumbsRouteTitles) {
        if (action.breadcrumbsRouteTitles.hasOwnProperty(key2)) {
          newState[key2] = newState[key2] ? newState[key2] : {} //newState[key2] may be undefined
          Object.assign(newState[key2], action.breadcrumbsRouteTitles[key2])
        }
      }

      return newState;
    default:
      return state;
  }
}

const message = (state = null, action) => {
  switch(action.type) {
    case 'SET_MESSAGE':
      return action.message;
    default:
      return state;
  }
}

const loading = (state = false, action) => {
  switch(action.type) {
    case 'SET_LOADING':
      return action.loading;
    default:
      return state;
  }
}

const adminBaseUrl = (state = null, action) => {
  return state
}

const ahBaseUrl = (state = null, action) => {
    return state
}

const rootReducer = combineReducers({
  routing, ahBaseUrl, adminBaseUrl,
  breadcrumbsRouteTitles, topbarButtons, message, loading
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers/index.js